export interface ItemFilter<T> {
    label: string;
    filterFn: (item: T) => any;
}

export interface DropdownFilter<T> {
    name: string,
    options: ItemFilter<T>[];
    matchWidth?: boolean;
}

export interface FilterConfig<T> {
    searchBox?: {
        placeholder: string;
        byFields: (keyof T)[];
    };
    radioButtons?: {
        defaultSelectionIndex?: number;
        options: ItemFilter<T>[];
    };
    dropdownList?: DropdownFilter<T>[];
    multipleDropdownList?: DropdownFilter<T>[];
    localStorageKey?: string;
}

export const radioButtonSplit = 'split';